export const enum SHUFTI_VARIANTS {
    DEFAULT = 'default',
    EMAIL = 'email',
    LINK = 'link'
}

export const enum SHUFTI_STATUS {
    REQUIRED = 'required',
    PENDING = 'pending',
    MANUAL = 'manual',
    VERIFIED = 'verified',
    INVALID = 'invalid'
}
